import {useContext, useState} from 'react'

import {inputSizes} from '@s-ui/react-atom-input'
import Context from '@s-ui/react-context'

const formFieldIds = {
  currentPassword: 'currentPassword',
  newPassword: 'newPassword',
  confirmNewPassword: 'confirmNewPassword'
}
const initFields = {
  [formFieldIds.currentPassword]: '',
  [formFieldIds.newPassword]: '',
  [formFieldIds.confirmNewPassword]: ''
}

export const useFormUserModifyPasswordConfiguration = () => {
  const {i18n} = useContext(Context)

  const [fields, setFields] = useState(initFields)
  const [validatedErrors, setValidatedErrors] = useState({})

  const checkConstraints = ({field, fields} = {}) => {
    const _errors = {}

    if (field) {
      const {name: fieldId} = field
      _errors[fieldId] = field.checkValidity() ? '' : i18n.t('USER_PROFILE.EDIT.PASSWORD.FIELD_CONSTRAINTS_ERROR_TEXT')
    } else {
      for (const formFieldId in formFieldIds) {
        const isValidField = fields[formFieldId] && fields[formFieldId].length >= 8
        _errors[formFieldId] = isValidField ? '' : i18n.t('USER_PROFILE.EDIT.PASSWORD.FIELD_CONSTRAINTS_ERROR_TEXT')
      }
    }

    if (fields[formFieldIds.newPassword] !== fields[formFieldIds.confirmNewPassword]) {
      _errors[formFieldIds.confirmNewPassword] = i18n.t('USER_PROFILE.EDIT.PASSWORD.PASSWORD_CONFIRMATION_ERROR_TEXT')
    }

    setValidatedErrors(prevErrors => ({
      ...prevErrors,
      ..._errors
    }))

    return _errors
  }

  const handleOnBlur = field => {
    checkConstraints({field, fields})
  }

  const handleOnChange = ({value, name: fieldId}) => {
    setFields(previousFields => ({...previousFields, [fieldId]: value}))
  }

  const isValidForm = errors => !Object.values(errors).some(error => error)

  const commonMoleculeInputFieldProps = {
    maxLength: 20,
    minLength: 8,
    onBlur: e => handleOnBlur(e.target),
    onChange: e => handleOnChange(e.target),
    pwHideLabel: i18n.t('COMMON.HIDE').toLowerCase(),
    pwShowLabel: i18n.t('COMMON.SHOW').toLowerCase(),
    required: true,
    size: inputSizes.LARGE,
    tabIndex: 0,
    type: 'sui-password'
  }

  const modifyPasswordFields = [
    {
      autoComplete: 'current-password',
      errorText: validatedErrors[formFieldIds.currentPassword],
      id: 'current-password',
      label: i18n.t('COMMON.CURRENT_PASSWORD'),
      name: formFieldIds.currentPassword,
      ...commonMoleculeInputFieldProps
    },
    {
      autoComplete: 'new-password',
      errorText: validatedErrors[formFieldIds.newPassword],
      id: 'new-password',
      label: i18n.t('COMMON.NEW_PASSWORD'),
      name: formFieldIds.newPassword,
      ...commonMoleculeInputFieldProps
    },
    {
      autoComplete: 'new-password',
      errorText: validatedErrors[formFieldIds.confirmNewPassword],
      id: 'confirm-new-password',
      label: i18n.t('COMMON.CONFIRM_NEW_PASSWORD'),
      name: formFieldIds.confirmNewPassword,
      ...commonMoleculeInputFieldProps
    }
  ]

  return {
    checkConstraints,
    commonMoleculeInputFieldProps,
    fields,
    formFieldIds,
    handleOnBlur,
    handleOnChange,
    modifyPasswordFields,
    isValidForm,
    validatedErrors
  }
}
